<div class="w-full">

  <div class="w-full h-25rem splash-bg">
  </div>

  <div dir="auto" class="w-full flex flex-column floating-container align-items-center">

    <div class="lg:w-11 sm:w-12" style="width:100%;">

      <p-card class="" styleClass="border-round-2xl p-2 shadow-5">
        <div class="layout-container">

          <div class="w-full flex flex-row justify-content-center px-3 py-4">
            <span [style.font-family]="articlesService.fontFamily" class="text-3xl font-bold text-black-alpha-90">{{articlesService.isEnglish?'Articles':'مقالات'}}</span>
          </div>

          <div *ngIf="networkState===1" class="flex flex-wrap justify-content-start" style="min-height: 65vh">

            <ng-container *ngFor="let article of articles">
              <div class="sm:fill-available md:w-6 lg:w-4 p-3">
                <p-card styleClass="border-round-2xl h-27rem shadow-5 p-0">
                  <a class="cursor-pointer" (click)="viewArticle(article.blogId)">
                    <div class="flex flex-column h-27rem gap-3">
                      <img
                        [src]="article.cover"
                        class="w-full h-15rem object-fill border-round-2xl bg-gray-200"
                        onerror="this.src='assets/images/splash2.png'"
                      >
                      <div style="height: 36vh" class="flex flex-column justify-content-between overflow-hidden text-overflow-ellipsis pb-2">
                        <span [style.font-family]="articlesService.fontFamily" class="w-full px-3 mb-1 text-black-alpha-90 font-semibold single-line text-xl">{{(articlesService.isEnglish?article.title:article.arTitle)??'--'}}</span>

                        <span [style.font-family]="articlesService.fontFamily" class="w-full h-full px-3" ellipsis [ellipsis-content]="articlesService.stripHtmlTags(articlesService.isEnglish?article.body:(article.arBody??'--'))"></span>

                        <div class="flex flex-row w-full justify-content-end gap-2 align-items-center px-3">
                          <svg-icon src="assets/icons/calendar.svg" [svgStyle]="{ 'width.rem':1 , 'height.rem':1 }"></svg-icon>
                          <span [style.font-family]="articlesService.fontFamily" class="text-color text-sm font-light">{{article.created | date}}</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </p-card>
              </div>


            </ng-container>

          </div>

          <ng-container *ngIf="networkState==0">
            <div class="w-full h-30rem flex justify-content-center align-items-center">
              <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
                                 animationDuration=".5s"></p-progressSpinner>
            </div>
          </ng-container>

          <a *ngIf="networkState === 2" (click)="getArticles()" class="cursor-pointer">
            <div class="w-full h-30rem flex flex-column justify-content-center align-items-center">
              <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
              <span [style.font-family]="articlesService.fontFamily" class="text text-700 mt-2">{{errorMsg}}</span>
            </div>
          </a>

          <div *ngIf="initialised" class="flex flex-row justify-content-end align-items-center mt-4">
            <p-paginator dir="ltr"
              styleClass="border-round-2xl"
              (onPageChange)="onPageChange($event)"
              [first]="first"
              [rows]="size"
              [totalRecords]="totalRecords" [rowsPerPageOptions]="[6, 15, 30]"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="{first} - {last} of {totalRecords}" [showPageLinks]="true" [showFirstLastIcon]="false"></p-paginator>
          </div>

        </div>
      </p-card>
    </div>

    <div class="flex flex-column mt-5">
      <p-divider ></p-divider>

      <div class="w-full h-5rem p-4">
        <span [style.font-family]="articlesService.fontFamily"class="font-light">
          {{articlesService.isEnglish?'&copy;2024 Q-Lift Elevators. Designed and Developed by ':'© 2024 مصاعد كيو ليفت. تصميم وتطوير '}}</span>
        <a target="_blank" href="https://web.facebook.com/Pixadvfb" class="cursor-pointer text-primary font-medium">
          <span [style.font-family]="articlesService.fontFamily" class="font-light">PixADV</span>
        </a>
      </div>
    </div>
  </div>

</div>



